import { axiosAjax } from '@app/src/config/axios';

export const priceService = {
  async get(categoryId: number, summaryId: string): Promise<any> {
    try {
      const { data } = await axiosAjax.get(
        process.env.API_PAYMENT_PRICE
          .replace(':categoryId', String(categoryId))
          .replace(':summaryId', '' + summaryId)
        );
      return data;
    } catch (e) {
      throw new Error(e);
    }
  }
}
